import {Theme} from "@material-ui/core";
import { HexToRGB } from "../../../../Utils/Utils";

export const OptionDarkWithBackdrop = (theme: Theme) => {
  const alpha = 0.0;
  const bgColor = {r: 44, g: 47, b: 52};
  const blurBgColor = `rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, ${alpha})`;
  return {
    root: {
      display: 'flex',
      overflowY: 'unset',
      '& > *': {
        backdropFilter: `saturate(200%) brightness(120%) blur(20px)`,
        background: blurBgColor,
      }
    },
    rootWithChildren: {
      display: 'flex',
      overflowY: 'unset',
      backdropFilter: `saturate(200%) brightness(200%) blur(80px)`,
      background: blurBgColor,
    },
  };
};

export const OptionLightWithBackdrop = (theme: Theme) => {
  return {
    root: {
      display: 'flex',
      overflowY: 'unset',
      '& > *': {
        background: theme.palette.background.paper,
      }
    },
    rootWithChildren: {
      display: 'flex',
      overflowY: 'unset',
      background: theme.palette.background.paper,
    },
  };
};

export const OptionLightWithNoBackdrop = (theme: Theme) => {
  const alpha = 1.0;
  const bgColor = HexToRGB(theme.palette.background.paper);
  const blurBgColor = `rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, ${alpha})`;
  return {
    root: {
      display: 'flex',
      overflowY: 'unset',
      '& > *': {
        background: theme.palette.background.paper,
      }
    },
    rootWithChildren: {
      display: 'flex',
      overflowY: 'unset',
      background: theme.palette.background.paper,
    },
  };
};

export const OptionDarkWithNoBackdrop = (theme: Theme) => {
  const alpha = 1.0;
  const bgColor = {r: 44, g: 47, b: 52};
  const blurBgColor = `rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, ${alpha})`;
  return {
    root: {
      display: 'flex',
      overflowY: 'unset',
      '& > *': {
        backdropFilter: `unset`,
        background: blurBgColor,
      }
    },
    rootWithChildren: {
      display: 'flex',
      overflowY: 'unset',
      backdropFilter: `unset`,
      background: blurBgColor,
    },
  };
};
